export default function CtaBand() {
  return (
    <section className="w-full bg-background-50 pt-16 md:pt-24">
      <div className="w-full px-4 md:px-8">
        <div className="rounded-lg bg-accent-100 border border-accent-200 px-6 md:px-10 py-10 md:py-14 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-7">
          <div className="max-w-2xl">
            <h2 className="font-heading font-bold text-accent-950 text-2xl md:text-3xl leading-snug">
              先挑一条，再决定要不要继续
            </h2>
            <p className="mt-3 text-accent-900 text-sm md:text-base leading-relaxed">
              黑料大全把热门榜、必看清单与高能盘点聚合成精华榜单，爆款合集按热度排序。从 TOP榜入口进，最快找到最炸的那条。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0">
            <a
              href="#top-chart"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-trophy-line" />
              进入 TOP榜
            </a>
            <a
              href="#must-read"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-accent-400 text-accent-900 text-sm font-medium hover:bg-accent-200/60 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bookmark-3-line" />
              看必看清单
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}